<template>
<!-- 3d建模 -->
    <div class="modeling">
        <modelingHeader></modelingHeader>
        <modelingMain></modelingMain>
        <modelingDisplay></modelingDisplay>
        <modelingDTechnology></modelingDTechnology>
        <modelingCennert></modelingCennert>
        <modelingModel @handleChange="changeName"></modelingModel>
        <paheFooter></paheFooter>
        <popUpwindow v-if="popUp_" :lin_k="link_" :codeid="codeid"  @close1="close1"></popUpwindow>
    </div>
</template>

<script>
// 引入头部模型
import modelingHeader from '@/common/modeling/modeling-header'
import modelingCennert from '@/common/modeling/modeling-cennert'
import modelingDisplay from '@/common/modeling/modeling-display'
import modelingDTechnology from '@/common/modeling/modeling-dTechnology'
import modelingMain from '@/common/modeling/modeling-main'
import modelingModel from '@/common/modeling/modeling-model'
//引入底部
import paheFooter from '@/common/index/pahe-footer'
//引入案例弹窗
import popUpwindow from '@/common/public/pop-upwindow'
export default {
    name: 'modeling',
    components:{
        modelingHeader,
        modelingCennert,
        modelingDisplay,
        modelingDTechnology,
        paheFooter,
        modelingModel,
        popUpwindow,
        modelingMain
    },
    data() {
        return {
            popUp_:false,
            link_:null,
            codeid:null,
            Pop_up_data:[
            
            ]
        }
    },
    methods:{
        changeName(link_){
            this.link_=link_.Model_link
            this.codeid=link_.codeid
            this.popUp_ = true
        },
        close1(){
            this.popUp_ = false
        }
    },
    mounted() {
        var modeling = localStorage.getItem('modeling');
        document.documentElement.scrollTop = modeling;
        if(this.$route.query.goid == "modeling"){
            const cloud = document.querySelector('.modelingCennert')
            document.documentElement.scrollTop = cloud.offsetTop - 60
        }
    },
    destroyed() {
        let i1 = document.documentElement.scrollTop;
        localStorage.setItem('modeling', i1)
    },
}
</script>
<style scoped>
</style>


// WEBPACK FOOTER //
// src/components/modeling.vue